import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';
import * as fromMedia from './media.reducer';
import * as MediaActions from './media.actions';
import { map } from 'rxjs/operators';
import { ApiService } from '@quorum/api';

@Injectable()
export class MediaEffects {
  loadMedia$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MediaActions.loadMedia),
      fetch({
        run: (action) => {
          // Your custom service 'load' logic goes here. For now just return a success action...
          return this.apiService.get(`v/1/vehicles/vehicles/${action.vehicleId}/media`).pipe(
            map((media) => {
              // here to ensure any previously encoded keys are handled
              media.forEach((media: any) => {
                Object.keys(media).forEach((key) => {
                  if (key !== 'tags') {
                    media[key] = decodeURIComponent(media[key]);
                  }
                });
              });
              return MediaActions.loadMediaSuccess({ media: media, vehicleId: action.vehicleId });
            })
          );
        },

        onError: (action, error) => {
          console.error('Error', error);
          return MediaActions.loadMediaFailure({ error });
        },
      })
    )
  );

  loadDeltaMedia$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MediaActions.loadDeltaMedia),
      fetch({
        run: (action) => {
          // Your custom service 'load' logic goes here. For now just return a success action...

          if (action.lastMedia !== null) {
            return this.apiService
              .get(`v/1/vehicles/vehicles/${action.vehicleId}/media?deltaMedia=${encodeURIComponent(action.lastMedia)}`)
              .pipe(
                map((media) => {
                  return MediaActions.loadDeltaMediaSuccess({ media: media, vehicleId: action.vehicleId });
                })
              );
          } else {
            return MediaActions.loadMedia({
              vehicleId: action.vehicleId,
            });
          }
        },

        onError: (action, error) => {
          console.error('Error', error);
          return MediaActions.loadMediaFailure({ error });
        },
      })
    )
  );

  deleteMedia$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MediaActions.deleteMediaFromServer),
      fetch({
        run: (action) => {
          // Your custom service 'load' logic goes here. For now just return a success action...
          return this.apiService
            .delete(`v/1/quorum/media/${encodeURIComponent(action.media.PK)}/${encodeURIComponent(action.media.SK)}`)
            .pipe(
              map((media) => {
                return MediaActions.deleteMediaFromServerSuccess({ media: action.media });
              })
            );
        },

        onError: (action, error) => {
          console.error('Error', error);
          return MediaActions.loadMediaFailure({ error });
        },
      })
    )
  );

  updateMedia$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MediaActions.updateMediaOnServer),
      fetch({
        run: (action) => {
          // Your custom service 'load' logic goes here. For now just return a success action...
          return this.apiService
            .put(
              `v/1/quorum/media/${encodeURIComponent(action.media.PK)}/${encodeURIComponent(action.media.SK)}`,
              action.media
            )
            .pipe(
              map((media) => {
                return MediaActions.updateMediaOnServerSuccess({ media: action.media });
              })
            );
        },

        onError: (action, error) => {
          console.error('Error', error);
          return MediaActions.updateMediaOnServerFailure({ error });
        },
      })
    )
  );
  constructor(private actions$: Actions, private apiService: ApiService) {}
}
